export default function(value, options) {
  const result = value !== options.value
  if (!result)
    return options.message
}



// WEBPACK FOOTER //
// ./src/validators/nonEqualityTo.js